module.exports = __webpack_public_path__ + "media/images/childcare/yamina@3x-596275cb3ba8b188679b1ddee8c333b6.jpg";